// src/pages/Headquarter/ViewHeadquarter.jsx
import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import headquarterService from '../../services/headquarter.service';
import Toast from '../../components/Toast/Toast';
import '../../styles/AddPages.css';

const ViewHeadquarter = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [hq, setHq]           = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast]     = useState(null);

  useEffect(() => {
    const fetchHQ = async () => {
      try {
        const res = await headquarterService.getHeadquarterById(id);
        if (res.success) setHq(res.data);
      } catch (err) {
        setToast({ message: 'Failed to fetch headquarter details', type: 'error' });
      } finally {
        setLoading(false);
      }
    };
    fetchHQ();
  }, [id]);

  if (loading) return <div className="add-headquarter-page"><p style={{ padding: 40 }}>Loading...</p></div>;
  if (!hq)     return <div className="add-headquarter-page"><p style={{ padding: 40 }}>Headquarter not found.</p></div>;

  const formatDate = (val) => {
    if (!val) return null;
    const d = new Date(val);
    return isNaN(d.getTime()) ? null : d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const Field = ({ label, value }) => (
    <div className="form-group">
      <label className="form-label" style={{ fontWeight: 600, color: '#555' }}>{label}</label>
      <div className="form-input" style={{
        background: '#f8f9fa', cursor: 'default',
        minHeight: 42, display: 'flex', alignItems: 'center',
      }}>
        {value || <span style={{ color: '#aaa' }}>—</span>}
      </div>
    </div>
  );

  return (
    <div className="add-headquarter-page">
      {toast && <Toast message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><a href="/dashboard/overview">Dashboard</a></li>
          <li className="breadcrumb-item"><a href="/headquarter/view">Headquarters</a></li>
          <li className="breadcrumb-item active">View Headquarter</li>
        </ol>
      </nav>

      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h4 className="page-title">Headquarter Details</h4>
        <button className="btn btn-primary" onClick={() => navigate(`/headquarter/edit/${id}`)}>
          ✏️ Edit Headquarter
        </button>
      </div>

      <div className="form-card">
        <div className="form-section">
          <div className="form-row">
            <Field label="Headquarter Name" value={hq.name} />
            <Field label="Region"           value={hq.region?.name} />
            <Field label="Company"          value={hq.company?.name} />
          </div>
          <div className="form-row">
            <Field label="Status"      value={hq.isActive ? '✅ Active' : '❌ Inactive'} />
            <Field label="Created On"  value={formatDate(hq.createdAt)} />
            <Field label="Updated On"  value={formatDate(hq.updatedAt)} />
          </div>
        </div>

        <div className="form-actions">
          <button className="btn btn-secondary" onClick={() => navigate('/headquarter/view')}>← Back</button>
          <button className="btn btn-primary"   onClick={() => navigate(`/headquarter/edit/${id}`)}>✏️ Edit</button>
        </div>
      </div>
    </div>
  );
};

export default ViewHeadquarter;